import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import Label from '../../../../../incase-domain/components/label/Label';
import DropdownMenuCompact from '../../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import Button from '../../../../../incase-domain/components/button/Button';

interface FormElementWidthChangeProps {
    width?: number;
    changeWidth: (width: number) => void;
}

FormElementWidthChange.defaultProps = {
    width: undefined,
};

function FormElementWidthChange({width, changeWidth}: FormElementWidthChangeProps): ReactElement {
    const {t} = useTranslation();

    const getWidth = (): number => {
        if (width === undefined || width == null) return 1;
        return width;
    };

    const formWidth = [
        {label: '25%', value: '0.25'},
        {label: '50%', value: '0.5'},
        {label: '75%', value: '0.75'},
        {label: '100%', value: '1'},
    ];

    return (
        <div className="l-group__item">
            <Label>{t('designSidepanel.width')}</Label>
            <DropdownMenuCompact
                width="full"
                items={[formWidth.map((el) => ({label: el.label, onClick: () => changeWidth(Number(el.value))}))]}
            >
                <Button className="c-sidepanel__dropdown_button" variant="soft" trailing="solar:alt-arrow-down-linear" size="xs" fullWidth>
                    {getWidth() * 100}%
                </Button>
            </DropdownMenuCompact>
        </div>
    );
}

export default FormElementWidthChange;
